// (C) Copyright 2014-2016 Hewlett Packard Enterprise Development LP

import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Button from 'grommet/components/Button';


class MapOverlay extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: this.props.show
    }
    this.hideOverlay = this.hideOverlay.bind(this);
    this.updateSite = this.updateSite.bind(this);
    this.handleSiteNameChange = this.handleSiteNameChange.bind(this);
  }
  componentWillMount() {

  }


  componentDidMount() {

  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      show: nextProps.show
    })
  }

  componentWillUnmount() {

  }
  hideOverlay() {
    this.props.closeOverlay();
  }
  updateSite() {
    let siteInfo = '';
    if (this.props.isUpdate) {
      siteInfo = this.refs.selectedSite.value;
    } else {
      siteInfo = this.refs.siteName.value;
    }

    this.props.updateSiteLocation(siteInfo);
    // this.props.closeOverlay();
  }

  handleSiteNameChange(){
    this.props.onSiteNameChange(this.refs.siteName.value);
  }


  render() {
    let toRender = null;
    if (this.props.isUpdate) {
      toRender = [<div key='0.1'>Link to Site</div>,
      <select key='0.2' name="" className="maxwidth" ref="selectedSite">
        {
          this.props.sites.map((item, index) => {
            return <option key={index} value={item.id}>{item.name}</option>
          })
        }
      </select>]
    } else {
      toRender = [<div key='0.3'>Create Site</div>,
      <input key='0.4' type="text" className="maxwidth" ref="siteName" placeholder="Enter site name." value= {this.props.value} onChange={this.handleSiteNameChange}/>]
    }
    return (
      <div className={'map-overlay ' + (this.props.show ? 'show' : 'hide')} >
        <div className="map-overlay-content">
          {toRender}
          <div className="overlay-btn-container">
            <Button
              label={this.props.isUpdate ? 'Update' : 'Create'}
              onClick={this.updateSite}
              primary={true}
              className="mr-5" />
            <Button
              label='Cancel'
              onClick={this.hideOverlay}
              primary={true} />
          </div>

        </div>
      </div>
    );
  }

}

export default MapOverlay;



// WEBPACK FOOTER //
// ./src/js/components/dashboard/MapOverlay.js